module.exports = __webpack_public_path__ + "img/6c.09d36eb9.png";